import React from 'react';
import CommonModal from "../../../utils/commonModal";
import { useDispatch } from "react-redux";
import { deletePollsAction, putPollsAction } from "../../../../../store/actions/cms/pollAction";

export const ConfirmDelete = (props) => {
  const dispatch = useDispatch();

  const handleAction = () => {
    const { delete: deleteId, id, status } = props.open || {};

    if (deleteId) {
      
      const param = { poll_id: deleteId };
      dispatch(deletePollsAction(param));
    } else if (typeof status !== undefined && typeof status !== null  && typeof id !== "undefined") {
      const updatedStatus = status === 'Published' ? 0 : 'Unpublished' ? 1 : 0
      const param = { id, status: updatedStatus };
      dispatch(putPollsAction(param));
    }

    props.setOpen(null);
  };

  const isDelete = !!props.open?.delete;
  const isStatusUpdate = typeof props.open?.status !== "undefined";

  const modalMessage = isDelete
    ? "Are you sure you want to delete?"
    : isStatusUpdate
    ? "Are you sure you want to change publishing status?"
    : "";

  return (
    <>
      {(isDelete || isStatusUpdate) && (
        <CommonModal
          isOpen={!!props.open}
          closeModal={() => props.setOpen(null)}
        >
          <div className="delete_confirmation">
            <div className="text_edit">{modalMessage}</div>
            <div className="icon_buttons">
              <button
                className="icon_edits icon_yes_color"
                onClick={handleAction}
              >
                Yes
              </button>
              <button
                className="icon_edits icon_no_color"
                onClick={() => props.setOpen(null)}
              >
                No
              </button>
            </div>
          </div>
        </CommonModal>
      )}
    </>
  );
};
